var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectedTvIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3H4C2.9 3 2 3.9 2 5V17C2 18.1 2.9 19 4 19H8V20C8 20.55 8.45 21 9 21H15C15.55 21 16 20.55 16 20V19H20C21.1 19 21.99 18.1 21.99 17L22 5C22 3.9 21.1 3 20 3ZM20 17H4V5H20V17ZM7 15.97C6.98 14.89 6.11 14.02 5.03 14H5V16H7V15.97ZM5.62 12.55C7.06 12.81 8.2 13.95 8.45 15.39C8.51 15.75 8.82 16 9.18 16C9.64 16 10 15.59 9.93 15.14C9.57 13.07 7.94 11.44 5.87 11.08C5.41 11 5 11.36 5 11.82C5 12.19 5.26 12.49 5.62 12.55ZM5.64 9.53C8.71 9.83 11.16 12.28 11.47 15.35C11.51 15.72 11.84 16 12.21 16C12.66 16 13 15.6 12.96 15.15C12.56 11.41 9.59 8.44 5.85 8.05C5.4 8 5 8.34 5 8.79C5 9.16 5.27 9.5 5.64 9.53Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedTvIcon);
export default __webpack_public_path__ + "static/media/ConnectedTVIcon.e4cbb8ba09606082a7d16a854029b0a0.svg";
export { ForwardRef as ReactComponent };